import React, { useState } from 'react';
import Box from '@mui/material/Box';
import ShippedReportForm from './ShippedReportForm'
import auditHelpers from '../../helpers/audits';

function ShippedReport(props) {

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleDateChange = (date, field) => {
        let func = setStartDate;
        if (field === "endDate") func = setEndDate;
        if (date !== null) {
            func({formatted: date.format("YYYY-MM-DD"), full: date});
        } else {
            func(date);
        };
    };

    const downloadShippedReport = async () => {
        props.setLoading(true);
        try {
            const res = await auditHelpers.getFullyShippedOrders(startDate.formatted, endDate.formatted, props.company, props.token);
            if (!res.success) {
                props.toast.error('Failed to get shipped orders!');
                return;
            } else if (res?.fully_shipped?.length) {
                await exportOrders(res?.fully_shipped);
            } else if (!res?.fully_shipped?.length) {
                window.alert('There are no fully shipped orders in this date range.');
            };
        } catch(err) {
            console.log('downloadShippedReport err', err)
            props.toast.error('Failed to get shipped orders!');
        } finally {
            clearOrderSearch();
            props.setLoading(false);
        };
    };

    const clearOrderSearch = async () => {
        setStartDate(null);
        setEndDate(null);
    };

    const exportOrders = async (orders) => {
        const today = new Date();
        const formattedDate = `${today.getMonth() + 1}.${today.getDate()}.${today.getFullYear().toString().slice(-2)}`;
        let data = [
            ["order_id", "order_date", "vendor_name", "internal_po_number", "pickup_time", "acu_order_num", "acu_ship_num"].join(",")
        ];
        for (let order of orders) {
            data.push(
                [order.order_id, order.order_date, order.vendor_name, order.internal_po_number, order.pickup_time, 
                order.acu_order_num, order.acu_ship_num].join(",")
            );
        }
        let csv = data.join("\n");
        let uri = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        let a = document.createElement("a");
        a.setAttribute("href", uri);
        a.setAttribute("download", `${formattedDate} Shipped Report.csv`);
        document.body.appendChild(a);
        a.click();
    };

    return(
        <Box className = {props.isMobile ? "mobile-top" : "desktop-top"} sx = {{display: 'flex', flexDirection: 'column'}}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 2}}>
                <h1>Shipped Orders Report</h1>
                <ShippedReportForm
                    isMobile = {props.isMobile}
                    handleDateChange = {handleDateChange}
                    startDate = {startDate?.full}
                    endDate = {endDate?.full}
                    clearOrderSearch = {clearOrderSearch}
                    downloadShippedReport = {downloadShippedReport}
                />
            </Box>
        </Box>
    )
}

export default ShippedReport;